const DEFAULT_LOCAL_API_BASE_URL = "http://localhost:5001";
const LIVE_CORE_API_BASE_URL = "https://financialedge-core-api.vercel.app";
const STAGING_CORE_API_BASE_URL = "https://financialedge-core-staging.vercel.app";

const LEGACY_API_HOSTNAME_MAP = Object.freeze({
    "balmoral-core-api.vercel.app": "financialedge-core-api.vercel.app",
});
const DEPLOYED_LOGIN_API_BASE_URLS = Object.freeze({
    "balmoral-login.vercel.app": "https://financialedge-core-api.vercel.app",
    "balmoral-login-vert.vercel.app": "https://financialedge-core-api.vercel.app",
    "financialedge-login.vercel.app": "https://financialedge-core-api.vercel.app",
    "financialedge-login-staging.vercel.app": "https://financialedge-core-staging.vercel.app",
});
const FINANCIAL_EDGE_LOGIN_HOST_PATTERN = /^financialedge-login(?:-[a-z0-9-]+)?\.vercel\.app$/i;
const STAGING_HOST_PATTERN = /(?:^|[-.])staging(?:[-.]|$)/i;
const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1", "0.0.0.0", "::1", "[::1]"]);

function trimTrailingSlashes(value) {
    return String(value || "").trim().replace(/\/+$/g, "");
}

export function normalizeApiBaseUrl(value, options = {}) {
    const configuredBaseUrl = trimTrailingSlashes(value);
    if (!configuredBaseUrl) {
        return inferApiBaseUrlFromHostname(options.hostname) || DEFAULT_LOCAL_API_BASE_URL;
    }

    try {
        const url = new URL(configuredBaseUrl);
        const canonicalHostname = LEGACY_API_HOSTNAME_MAP[url.hostname.toLowerCase()];
        const deployedLoginApiBaseUrl = inferApiBaseUrlFromHostname(options.hostname);

        if (canonicalHostname) {
            url.hostname = canonicalHostname;
        }

        if (deployedLoginApiBaseUrl && LOCAL_HOSTNAMES.has(String(url.hostname || "").trim().toLowerCase())) {
            return deployedLoginApiBaseUrl;
        }

        if (
            STAGING_HOST_PATTERN.test(String(options.hostname || "").trim().toLowerCase()) &&
            (LOCAL_HOSTNAMES.has(String(url.hostname || "").trim().toLowerCase()) ||
                trimTrailingSlashes(url.origin) === LIVE_CORE_API_BASE_URL)
        ) {
            return STAGING_CORE_API_BASE_URL;
        }

        return trimTrailingSlashes(url.toString());
    } catch {
        return configuredBaseUrl;
    }
}

export function inferApiBaseUrlFromHostname(hostname = "") {
    const normalizedHostname = String(hostname || "").trim().toLowerCase();

    if (!normalizedHostname) {
        return "";
    }

    if (DEPLOYED_LOGIN_API_BASE_URLS[normalizedHostname]) {
        return DEPLOYED_LOGIN_API_BASE_URLS[normalizedHostname];
    }

    if (FINANCIAL_EDGE_LOGIN_HOST_PATTERN.test(normalizedHostname) && STAGING_HOST_PATTERN.test(normalizedHostname)) {
        return "https://financialedge-core-staging.vercel.app";
    }

    return "";
}

function getBrowserHostname() {
    if (typeof window === "undefined") {
        return "";
    }

    return window.location?.hostname || "";
}

export function getApiBaseUrl(env = process.env) {
    const hostname = getBrowserHostname();
    return normalizeApiBaseUrl(
        env.REACT_APP_API_URL ||
        inferApiBaseUrlFromHostname(hostname) ||
        DEFAULT_LOCAL_API_BASE_URL,
        { hostname }
    );
}
